import { render, staticRenderFns } from "./HeroMain.vue?vue&type=template&id=681d5ba0&lang=true&"
import script from "./HeroMain.vue?vue&type=script&lang=js&"
export * from "./HeroMain.vue?vue&type=script&lang=js&"
import style0 from "./HeroMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports